<ng-content select="[concept-button-icon]"></ng-content>
@if (icon) {
  <campus-icon [svgIcon]="icon"></campus-icon>
}

@if (plainTooltip) {
  <campus-tooltip
    [plainTooltip]="plainTooltip"
    [tooltipDelay]="250"
    [anchor]="element"
    class="[ visually-hidden ]"
    >
  </campus-tooltip>
}

@if (badge) {
  <dcr-badge [count]="badge" class="[ absolute -top-2xs -right-2xs ]"></dcr-badge>
}

<dcr-state-layer
  [ngClass]="selected ? 'bg-on-surface-variant' : 'bg-on-surface-inverse'"
  [for]="element"
  type="circular"
></dcr-state-layer>
<dcr-focus-ring [for]="element"></dcr-focus-ring>
